// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { serverUrl } from "../../temp";

// const AccountSingle = () => {
//   // Extracting accountID using regular expressions
//   const location = useLocation();
//   // const accountID = location.pathname.match(/\/account\/(\d+)/);
//   const accountID = location.pathname.match(/\/account\/(\d+)/)?.[1];

//   const [account, setAccount] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchAccount = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/account/${accountID}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch account');
//       // }
//       const data = await response.json();
//       setAccount(data);
//       localStorage.setItem("accountData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (accountID) {
//       fetchAccount();
//     }
//   }, [accountID]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">account Information</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{account?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{account?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{account?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">User Id: </span>
//                     <span className="itemValue">{account?.data.user_id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Description: </span>
//                     <span className="itemValue">
//                       {account?.data.description}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Bank Id: </span>
//                     <span className="itemValue">{account?.data.bank_id}</span>
//                   </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">amount: </span>
//                     <span className="itemValue">{account?.data.balance}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Transaction Id: </span>
//                     <span className="itemValue">
//                       {account?.data.transaction_id}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Transaction Type: </span>
//                     <span className="itemValue">
//                       {account?.data.transaction_type}
//                     </span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Status: </span>
//                     <span className="itemValue">{account?.data.status}</span>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default AccountSingle;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const AccountSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accountID = location.pathname.match(/\/account\/(\d+)/)?.[1];
  const [account, setAccount] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchAccount = async () => {
    try {
      const response = await fetch(`${serverUrl}/account/${accountID}`);
      const data = await response.json();
      setAccount(data);
      localStorage.setItem("accountData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  useEffect(() => {
    if (accountID) {
      fetchAccount();
    }
  }, [accountID]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Account Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Account Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Account Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Account Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        {account?.data.name}
                      </h1>

                      <div className="mb-4">
                        <div className="text-3xl font-bold text-purple-600">
                          {formatCurrency(account?.data.balance)}
                        </div>
                        <p className="text-sm text-gray-500">Current Balance</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSingle;
